import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';

export const Container: StyleRule = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: pxArrayToRem([0, 10]),
    padding: pxArrayToRem([24, 26, 28]),
    background: 'rgba(20,20,20,0.7)',
    borderRadius: pxToRem(16),
    backdropFilter: 'blur(16px)',

    [theme.screen.laptop]: {
        width: pxToRem(395),
        margin: 0,
    },
});

export const Title: StyleRule = () => ({
    color: '#fff',
    fontSize: pxToRem(20),
    lineHeight: pxToRem(26),
    letterSpacing: '0.4px',
    textAlign: 'center',
});

export const Text: StyleRule = () => ({
    maxWidth: pxToRem(300),
    marginTop: pxToRem(8),
    color: '#fff',
    fontSize: pxToRem(14),
    lineHeight: pxToRem(20),
    letterSpacing: 0,
    textAlign: 'center',
});

export const Button: StyleRule = () => ({
    width: pxToRem(170),
    height: pxToRem(42),
    display: 'flex',
    gap: pxToRem(4),
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: pxToRem(31),
    background: '#fff',
    color: '#141414',
    fontSize: pxToRem(14),
    fontWeight: 500,
    lineHeight: 1,
    letterSpacing: 0,
    borderRadius: pxToRem(30),
    cursor: 'pointer',
});

export const ButtonLabel: StyleRule = () => ({
    marginTop: pxToRem(1),
});
